import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const WalletTitle = ({ title, subTitle, subUrl }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="tile-header__container">
        <div className="tile-header__text">{title}</div>
        <div className="tile-header__sub">
          <Link href={subUrl ?? ''}>
            <a className="tile-header__link">{subTitle}</a>
          </Link>
        </div>
      </div>
      <style jsx>{`
        .tile-header__container {
          display: flex;
        }
        .tile-header__sub {
          margin-left: auto;
        }
        .tile-header__link {
          font-weight: 700;
          font-size: 15px;
          font-style: italic;
          color: ${theme.colors.primary};
        }
        .tile-header__link:hover {
          color: #23527c;
          text-decoration: underline;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .tile-header__sub {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

WalletTitle.propTypes = {
  subTitle: PropTypes.string.isRequired,
  subUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default WalletTitle;
